import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BuscadorMedicamentos from "./components/buscador/BuscadorMedicamentos";
import FormularioInscripcion from "./components/cicletada/FormularioInscripcion";

function App() {
  return (
    <Router>
      <div>
        <header>
          <Routes>
            <Route path="/" element={<BuscadorMedicamentos />} />
            <Route path="/cicletada" element={<FormularioInscripcion />} />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
